import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './List.m.sass';
var List = function List(_ref) {
  var children = _ref.children,
    addButton = _ref.addButton;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.list
  }, children), addButton && /*#__PURE__*/React.createElement("div", {
    className: styles.addButton
  }, addButton));
};
export default observer(List);
//# sourceMappingURL=index.js.map
